import React from 'react';
import { Switch } from '@headlessui/react'
import {classNames} from '../../../Services/helpers';
import Loading from '../../Loading';

const TheToggle = ({enabled, onChange, hideFocusRing, label, className, disabled, help, loading = false, ring = false}) => {

    if (label) {
        return <Switch.Group as="div" className={classNames(
            className,
            ring && 'rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-brand p-2'
        )}>
            <div className="flex items-center">
                <Switch.Label as="span" className="mx-1 pr-1 text-sm text-left w-full pr-3">
                    <span className="font-medium text-gray-900 text-balance">{label}</span>
                </Switch.Label>

                {loading ? <Loading inline /> : <TheSwitch {...{enabled, onChange, hideFocusRing, disabled}} />}
            </div>

            {help && <p className="mt-2 text-muted text-xs">{help}</p>}

        </Switch.Group>
    }

    return <TheSwitch {...{enabled, onChange, hideFocusRing, disabled}} />
}

const TheSwitch = ({enabled, onChange, hideFocusRing, disabled}) => {
    return <Switch
            checked={enabled}
            onChange={onChange}
            className={classNames(
                disabled ? (enabled ? 'bg-brand/50' : 'bg-gray-100') : (enabled ? 'bg-brand' : 'bg-gray-200'),
                'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none',
                hideFocusRing ? '' : 'focus:ring-2 focus:ring-brand focus:ring-offset-2'
            )}
            disabled={disabled}
        >
        <span className="sr-only">Use setting</span>
        <span
            className={classNames(
            enabled ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
            )}
        >
            <span
                className={classNames(
                    enabled ? 'opacity-0 duration-100 ease-out' : 'opacity-100 duration-200 ease-in',
                    'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                )}
                aria-hidden="true"
            >
                <svg className={classNames('h-3 w-3', disabled ? 'text-gray-200' : 'text-gray-400')} fill="none" viewBox="0 0 12 12">
                    <path
                        d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
            <span
                className={classNames(
                    enabled ? 'opacity-100 duration-200 ease-in' : 'opacity-0 duration-100 ease-out',
                    'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                )}
                aria-hidden="true"
            >
                <svg className={classNames('h-3 w-3 ', disabled ? 'text-brand/50' : 'text-brand')} fill="currentColor" viewBox="0 0 12 12">
                    <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                </svg>
            </span>
        </span>
    </Switch>
}

export default TheToggle;
